import { Card } from '@llt-frontend/react-material-card';
import Motion from '../motion';
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import useSlideInOut from '../../hooks/motion/use-slide-in-out';

//

const TYPES = {
  primary: 1,
  success: 2,
};

function NotificationCard({ action, children, heading, motionId, type = TYPES.primary }) {
  const slideInOutVariants = useSlideInOut({
    animationOffset: '100%',
    duration: 1,
  });

  //
  // Render

  return (
    <Card
      className={classNames('notification-card', {
        'notification-card--success': type === TYPES.success,
      })}
    >
      <Motion
        {...{ motionId }}
        className="notification-card__motion"
        simple
        variants={slideInOutVariants}
      >
        <div className="notification-card__content">
          <div className="notification-card__heading">{heading}</div>

          <div className="notification-card__description">{children}</div>
        </div>

        <div className="notification-card__action">{action}</div>
      </Motion>
    </Card>
  );
}

NotificationCard.propTypes = {
  action: PropTypes.node,
  children: PropTypes.node,
  motionId: PropTypes.string,
  heading: PropTypes.node,
};

// Exports
// -------

export { TYPES };

export default NotificationCard;
